export const Imagegallery = () => {
    const imageData = [
      { image: "/images/Price/17.jpg", title: "Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring", price: "₹119", amazon: "https://amzn.to/3F49GXV" , alttext:"Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring"},
      { image: "/images/Price/18.jpg", title: "Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring", price: "₹119", amazon: "https://amzn.to/3F49GXV" , alttext:"Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring"},
      { image: "/images/Price/19.jpg", title: "Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring", price: "₹119", amazon: "https://amzn.to/3F49GXV" , alttext:"Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring"},
      { image: "/images/Price/20.jpg", title: "Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring", price: "₹119", amazon: "https://amzn.to/3F49GXV" , alttext:"Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring"},
      { image: "/images/Price/21.jpg", title: "Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring", price: "₹119", amazon: "https://amzn.to/3F49GXV" , alttext:"Shinzura Acne Pimple Patches - 36 Hydrocolloid Waterproof Patches with 0.5% Salicylic Acid | Absorbs Pimples Overnight & Prevents Scarring"},
    ];
  
    const ImageCard = ({ image, title, price, alttext, amazon }) => (
      <div className="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a href={amazon} className="block relative rounded overflow-hidden">
          <img
            alt={alttext}
            className="object-cover object-center w-full h-full block"
            src={image}
          />
        </a>
        <div className="mt-4">
          <h2 className="text-gray-900 title-font text-lg font-medium">{title}</h2>
          <p className="mt-1">{price}</p>
          <a href={amazon} target="_blank" rel="noopener noreferrer" className="text-indigo-500 inline-flex items-center mt-2">
              Buy Now
              <svg
                className="w-4 h-4 ml-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14m0 0l-7-7m7 7l-7 7" />
              </svg>
            </a>
        </div>
      </div>
    );
  
    return (
      <div className="bg-white text-gray-800 font-sans">
        <h1 className="text-4xl font-bold text-center text-pink-600 mb-6">Image Gallery</h1>
        <section className="text-gray-600 body-font">
          <div className="container px-5 py-6 mx-auto">
            <div className="flex flex-wrap -m-4">
              {imageData.map((item, index) => (
                <ImageCard
                  key={index}
                  image={item.image}
                  title={item.title}
                  price={item.price}
                  amazon={item.amazon}
                  alttext={item.alttext}
                />
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  };
  